import { TranslateService } from './../../shared/translate/translate.service';
import { AuthService } from './../../shared/models/auth.service';
import { IKeyValueInterface, WeGoAuthorizedLink, Permission, PermissionType, Entity } from './../../shared/config';
import { Component, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Observable } from 'rxjs/Observable';
import { Router, ActivatedRoute } from '@angular/router';
import { WeGoConfig, IAPIResponse, ApplicationRouteURL, UserRoles, DataListModel } from '../../shared/config';
import { Location } from '@angular/common';
import { OrganizationService } from '../../organization/models/organization.service';
import { OrganizationSubscriptionService } from '../models/organization-subscription.service';
import { SubscriptionModel } from '../models/organization-subscription.model';
import { ModalDirective } from 'ng2-bootstrap/components/modal';

@Component({
  selector: 'wego-organization-subscription-mapping',
  template: require('../views/organization-subscription-list.component.html'),
  providers: [OrganizationService, OrganizationSubscriptionService],
})
export class OrganizationSubscriptionComponent implements OnInit {
  urlVehicleUpdate: string;
  DataListModel: DataListModel;
  subscriptionList: SubscriptionModel[];
  errorModel: IKeyValueInterface[];
  errorMessage: string;
  isLoading: boolean;
  message: string;
  OrganizationHashId: string = "";
  deleteSubscriptionMapHashId: string
  organizationName: string;
  deleteMessage: string;
  isParentCheck: boolean;
  apiResponse: IAPIResponse;
  urlDefaultPage: string;
  urlOrganizationList: string;
  addOrganizationSubscriptionLink: WeGoAuthorizedLink;

  private validationMessage: string;
  private popupTitle: string;
  private popupMsg: string;
  private module: string;

  @ViewChild('deleteModal') public deleteModal: any;
  @ViewChild('assignSubscriptionToOrganizationModal') public assignSubscriptionToOrganizationModal: any;
  @ViewChild('successPopup') public successPopup: any;
  @ViewChild('alertModal') public alertModal: ModalDirective;

  get isAnyChecked(): boolean {
    if (this.subscriptionList) {
      let isCheck = this.subscriptionList.some(x => x.isChecked == true);
      if (isCheck) {
        if (this.subscriptionList.every(x => x.isChecked == true))
          this.isParentCheck = true;
        else
          this.isParentCheck = false;
      }
      else {
        this.isParentCheck = false;
      }

      return isCheck;
    }
    else {
      this.isParentCheck = false;
      return false;
    }
  }

  constructor(private organizationService: OrganizationService,
    private organizationSubscriptionService: OrganizationSubscriptionService
    , private activeRoute: ActivatedRoute
    , private router: Router
    , private authService: AuthService
    , private translate: TranslateService,
    private locationService: Location) {
  }

  ngOnInit() {
    this.module = this.translate.instant('LblSubscription')
    this.DataListModel = this.authService.RetriveFilter(this.constructor.name);
    this.DataListModel.searchField = ["name","groupName", "timeInterval", "invoiceInterval", "paymentInterval"];
    this.urlDefaultPage = this.authService.GetURL(ApplicationRouteURL.URL_DEFAULT_PAGE);
    this.urlOrganizationList = this.authService.GetURL(ApplicationRouteURL.URL_ORGANIZATION_LIST);   
    this.activeRoute
      .params
      .subscribe(params => {
        let OrganizationHashId = params['id'] || '';
        if (OrganizationHashId != '') {
          this.OrganizationHashId = OrganizationHashId;
          this.addOrganizationSubscriptionLink = new WeGoAuthorizedLink("",
            Permission.PR_ORGANIZATION_SUBSCRIPTION_OVERVIEW, PermissionType.INSERT, 'btn btn-highlight navbar-right', 'LblAddNew', Entity.ORGANIZATION, this.OrganizationHashId);
            
          this.GetSubscriptionListByOrganizationList();
          this.GetOrganizationDetailByHashId();
        }
      });
  }

  public OnExport(event: any) {
    this.isLoading = true;
    this.organizationSubscriptionService.ExportSubscriptionList(this.OrganizationHashId, this.DataListModel)
      .subscribe(
      (res: any) => {
        if (res && res._body) {
          let fileName = "SubscriptionToOrganization" + new Date().toISOString() + ".csv";
          this.authService.DownloadFile(fileName, res._body);
        }
        this.isLoading = false;
      },
      (error: any) => {
        this.errorMessage = this.authService.HandleErrorStatusCode(error);
        this.isLoading = false;
      });
  }
  public OnSort(sortName: string) {
    this.DataListModel.sortType = sortName;
    this.DataListModel.sortReverse = !this.DataListModel.sortReverse;
    this.GetSubscriptionListByOrganizationList();
  }

  public OnSearch(event: any) {
    this.DataListModel = this.authService.GetSearchParameters(this.DataListModel, event.searchTerm, event.isReset);
    this.GetSubscriptionListByOrganizationList();
  }

  public OnPageChanged(event: any): void {
    this.DataListModel.currentPage = event.page;
    this.GetSubscriptionListByOrganizationList();
  };

  public OnPagingChange(event: any) {
    console.log(this.DataListModel);
    this.DataListModel.currentPage = 1;
    this.DataListModel.totalItems = 0;
    this.DataListModel.itemsPerPage = event.itemPerPage;
    this.GetSubscriptionListByOrganizationList();
  }

  public OnParentCheck(isChecked: boolean) {
    this.subscriptionList.forEach(x => x.isChecked = isChecked);
  }

  public DeleteSubscriptionMapping(subscriptionMapHashId:string) {
    this.isLoading = true;
    this.organizationSubscriptionService.DeleteSubscriptionMapping(subscriptionMapHashId)
      .subscribe(
      res => {
        if (res.data) {
        this.apiResponse = res;
        this.DataListModel.currentPage = 1;
        this.GetSubscriptionListByOrganizationList();
        this.popupMsg = this.translate.instant('LblRecordRemovedSuccess', [this.module]);
        this.ShowSuccessPopup();
      } else {
        this.validationMessage = res.error;
        this.popupTitle = this.translate.instant('LblWarning');
        this.ShowAlertModal();
      }
      },
      error => {
        this.errorMessage = this.authService.HandleErrorStatusCode(error);
        this.isLoading = false;
      });
  }

  public ShowDeleteModal(subscriptionMapHashId: string): void {
    this.deleteSubscriptionMapHashId = subscriptionMapHashId;
    this.popupMsg = this.translate.instant('LblRecordDeleteConfirmation', [this.module]);
    this.deleteModal.show();
  }

  public HideDeleteModal(): void {
    this.deleteSubscriptionMapHashId = "";
    this.deleteModal.hide();
  }

  public SuccessModalClick(): void {
    this.DeleteSubscriptionMapping(this.deleteSubscriptionMapHashId);
    this.deleteModal.hide();
  }

  public GetSubscriptionListByOrganizationList() {
    this.isLoading = true;
    this.organizationSubscriptionService.GetSubscriptionListByOrganizationHashId(this.OrganizationHashId, this.DataListModel)
      .subscribe(
      res => {
        this.subscriptionList = res.data;
        this.DataListModel.totalItems = res.totalRecords;
        this.DataListModel.infoMessage = res.error;
        this.isLoading = false;
      },
      error => {
        this.errorMessage = this.authService.HandleErrorStatusCode(error);
        this.isLoading = false;
      });
  }
  public GetOrganizationDetailByHashId() {
    this.organizationService.GetOrganizationBasicDetail(this.OrganizationHashId)
      .subscribe(
      res => {
        this.organizationName = res.data.entityName;
      },
      error => {
        this.errorMessage = this.authService.HandleErrorStatusCode(error);
        this.isLoading = false;
      });
  }
  public ShowAssignSubscriptionToOrganizationModal() {
    this.assignSubscriptionToOrganizationModal.OrganizationHashId = this.OrganizationHashId;
    this.assignSubscriptionToOrganizationModal.show();
  }

  public SuccessAssignSubscriptionModal($event: any) {
    this.GetSubscriptionListByOrganizationList();
    this.popupMsg = this.translate.instant('LblRecordAddedSuccess', [this.module]);//$event.SuccessMessage;
    this.ShowSuccessPopup();
  }

  public ShowSuccessPopup(): void {
    this.successPopup.show();
  }

  public HideSuccessPopup(): void {
    this.successPopup.hide();
    // this.OnBackClick();
  }

  public ConfirmSuccessPopup(): void {
    this.successPopup.hide();
    // this.OnBackClick();
  }

  public SuccessAlertModalClick(): void {
    this.alertModal.hide();
  }

  public ShowAlertModal(): void {
    this.isLoading = false;
    this.alertModal.show();
  }

  public OnBackClick() {
    this.locationService.back();
  }
  ngOnDestroy() {
    this.authService.SetFilter(this.constructor.name, this.DataListModel);
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/organizationsubscription/components/organization-subscription-list.component.ts